import React, { useEffect, useState } from 'react'
import { get } from 'lodash'
import { useHistory }  from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import AdminCommonListLayout from './AdminCommonListLayout'
import { adminVouchersList } from '../actions/admin_vouchers'
import { makeStyles, TextField, InputAdornment, IconButton } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import ClearIcon from '@material-ui/icons/Clear'
import { capitalize } from 'lodash'
import Timestamp from '../../components/Timestamp'

const useStyles = makeStyles((theme) => ({
  voucher_image: {
      maxWidth: '120px',
  },
  searchBox: {
    minWidth: '300px',
    marginBottom: '16px',
  }
}))

export const AdminVouchers = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const classes = useStyles()
  const is_loading = useSelector(() => adminVouchersList.isLoading())
  const [searchValue, setSearchValue] = useState('')
  const [searchTimeout, setSearchTimeout] = useState(null)

  const handleSearch = (value) => {
    setSearchValue(value)

    if (searchTimeout) {
      clearTimeout(searchTimeout)
    }

    const timeout = setTimeout(() => {
      dispatch(adminVouchersList.updateListFilter({ search: value }))
      dispatch(adminVouchersList.fetchListIfNeeded(true))
    }, 500)
    setSearchTimeout(timeout)
  }

  const handleClearSearch = () => {
    setSearchValue('')
    dispatch(adminVouchersList.updateListFilter({ search: '' }))
    dispatch(adminVouchersList.fetchListIfNeeded(true))
  }

  const columns = [
    {
      field: 'code',
      title: 'Code',
    },
    {
      field: 'status',
      title: 'Status',
      render: (item) =>
        <div>
          { capitalize(get(item, 'status')) }
        </div>
    },
    {
      field: 'expires_at',
      title: 'Expiry Date',
      render: (item) => <div>
        <Timestamp value={get(item, "expires_at")} format="date" />
      </div>,
    },    
    {
      field: 'voucher_type',
      title: 'Type',
      render: (item) =>
        <div>
          { capitalize(get(item, 'voucher_type')) }
        </div>      
    },
    {
      field: 'currency_name',
      title: 'Currency',
    },
    {
      field: 'max_amount',
      title: 'Max Amount',
    },
    {
      field: 'max_photos',
      title: 'Max Photos',
    },
    {
      field: 'voucher_discount',
      title: 'Discount',
      render: (item) => get(item, 'voucher_discount') ? `${get(item, 'voucher_discount')}%` : '',
    },
    {
      field: 'max_utilization',
      title: 'Max Utilization',
    },
    {
      field: 'num_times_used',
      title: 'Num Times Used',
    },
    {
      field: 'email',
      title: 'Email Address',
    },
    {
      field: 'gallery_name',
      title: 'Gallery',
    },
    {
      field: 'event_name',
      title: 'Event',
    },
    {
      field: 'photographer_name',
      title: 'Photographer',
    },    
    {
      field:  'edit',
      title:  'Edit',
      render: (item) =>
        <div>
          <button
            onClick={() => onEditVoucher(get(item, 'id'))}>
            Edit
          </button>
        </div>
    },
  ]

  useEffect(() => {
    async function fetchStaticObjects() {
      dispatch(adminVouchersList.updateListPagination({items_per_page: 10, page: 1}))
      dispatch(adminVouchersList.fetchListIfNeeded())
    }
    fetchStaticObjects()
  }, [])

  const onAddVoucher = () => {
    history.push('/admin/voucher/')
  }

  const onEditVoucher = (voucher_id) => {
    history.push(`/admin/voucher/${ voucher_id }`)
  }

  const renderSearchBox = () => {
    return (
      <TextField
        className={classes.searchBox}
        placeholder="Search by code or email..."
        value={searchValue}
        onChange={(e) => handleSearch(e.target.value)}
        variant="outlined"
        size="small"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
          endAdornment: searchValue && (
            <InputAdornment position="end">
              <IconButton size="small" onClick={handleClearSearch}>
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    )
  }

    return (
      <AdminCommonListLayout
        active_key='vouchers'
        breadcrumbs={[
          { name: 'admin_home' },
          {
            name: 'vouchers',
            label: 'Vouchers',
            url: '/admin/vouchers',
          },
        ]}
        add_label='Add voucher'
        columns={ columns }
        is_loading={ is_loading }
        onAddRow={ onAddVoucher }
        item_list={ adminVouchersList }
        renderAdditionalActions={ renderSearchBox }
      />
    )
}
